import { render, staticRenderFns } from "./tablePage.vue?vue&type=template&id=e0dbb670&scoped=true"
import script from "./tablePage.vue?vue&type=script&lang=js"
export * from "./tablePage.vue?vue&type=script&lang=js"
import style0 from "./tablePage.vue?vue&type=style&index=0&id=e0dbb670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dbb670",
  null
  
)

export default component.exports